/* ===== Contract-expiry helpers =====
   Trades carry an exact `expiry` (YYYY-MM-DD) stamped by the scanners from
   Kite's instrument dump (holiday shifts included); historical records were
   backfilled (weekly symbols parsed exactly; monthlies inferred from the
   index's weekly cadence, flagged expiryInferred). The weekly-symbol parser
   here is only a fallback for anything the backfill missed. */

const MONTH_CODE = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, O: 10, N: 11, D: 12 };

export function parseWeeklyExpiry(symbol) {
  const m = /^(NIFTY|BANKNIFTY|SENSEX|FINNIFTY|MIDCPNIFTY|BANKEX)(\d{2})([1-9OND])(\d{2})\d+(?:CE|PE)$/.exec(symbol || "");
  if (!m) return null;
  const yy = 2000 + Number(m[2]), mo = MONTH_CODE[m[3]], dd = Number(m[4]);
  if (!mo || dd < 1 || dd > 31) return null;
  return `${yy}-${String(mo).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
}

export const expiryOf = (t) => t?.expiry || parseWeeklyExpiry(t?.tradingsymbol) || null;

export const entryDayOf = (t) => {
  const d = new Date(t?.time || t?.placedAt);
  return isNaN(d) ? null : d.toLocaleDateString("en-CA");
};

/* true when the trade was taken ON its contract's expiry day (0DTE) */
export function isExpiryDay(t) {
  const e = expiryOf(t), d = entryDayOf(t);
  return !!(e && d && e === d);
}

/* calendar days from entry to contract expiry; null when unknown */
export function dteOf(t) {
  const e = expiryOf(t), d = entryDayOf(t);
  if (!e || !d) return null;
  return Math.round((new Date(e + "T00:00:00") - new Date(d + "T00:00:00")) / 86400000);
}

/* distinct entry days in a trade list — denominator for avg-per-day P&L */
export function tradingDaysOf(trades) {
  const s = new Set();
  for (const t of trades) { const d = entryDayOf(t); if (d) s.add(d); }
  return s.size;
}
